module.exports = {
	config: {
		roleOptionScope: 'mblx',
	},

	model: {
		entityTable: false
	},

	events: {
		action: {
			type: 'click',
			selector: 'section.top button',
			action: function(event){
				event.preventDefault()
				event.stopImmediatePropagation()

				const self = event.data.component
				const $target = $(event.target)
				if($target.length > 0){
					const fieldType = $target.data('fieldType')
					const buttonMode = $target.data('buttonMode')
					if(self.model.entityTable){
						if(fieldType === 'refresh'){
							self.model.entityTable.refreshData()
						} else if(fieldType === 'choose'){
							self.choose(buttonMode)
						}
					}
				}
			}
		}
	},

	methods: {
		prepare(){
			let modal
			this.closest('base_modal_modal', m => modal = m)
			if(!modal) return;

			const {
				productAttributes = {}
			} = (modal.model || {}).decisionScope || {}

			this.model.productAttributes = productAttributes
		},

		choose(buttonMode){
			if(buttonMode === 'ignore'){
				return this.decideClosest({
					decision: 'ignore',
					promptID: null,
				})
			}
			if(buttonMode === 'empty'){
				return this.decideClosest({
					decision: 'empty',
					promptID: null,
				})
			}

			console.error('UNKNOWN BUTTON_MODE', buttonMode)
		},

		async decided({decision, promptID} = {}){
			// NOTE: this function is used to prevent the fec/lib/component.js default code for performDecisions() to destroy the component prematurely.
		},
	},

	hooks: {
		attach: function($element, options){
			if(!this.model.entityTable){
				this.find('base_tableSimple_table', t => this.model.entityTable = t)
			}
		},

		filtersChanged: function($element, options){
			this.triggerFind('filtersChanged', options);
		},

		// TODO: POIAA: get colTagsBubble.click to work
		colTagsBubbleSelected: function($element, options){
			this.triggerFind('colTagsBubbleSelected', options);
		},
	}
};
